<!-- eslint-disable vue/no-dupe-v-else-if -->
<template>
  <div id="app">
    <!-- Progress bar -->
    <vue-progress-bar />

    <!-- Change password view -->
    <div
      v-if="['/change-password', '/reset-password'].includes(this.$route.path)"
      style="
        width: 100%;
        max-width: 100vw;
        height: auto;
        min-height: 100vh;
        overflow: hidden;
        box-sizing: border-box;
      "
    >
      <router-view />
    </div>

    <!-- Public view -->
    <div
      v-if="!isAdminLayout"
      :class="class_var"
      style="
        width: 100%;
        max-width: 100vw;
        height: auto;
        min-height: 100vh;
        overflow: hidden;
        box-sizing: border-box;
      "
    >
      <router-view />
    </div>

    <!-- Admin view -->
    <div
      v-else
      class="base-container-default"
      :class="{
        'base-container-cc': statusTheme == 'cc' || statusTheme == 'CC',
        'base-container-kokoro':
          statusTheme == 'kokoro' || statusTheme == 'Kokoro',
      }"
    >
      <AsideMenu
        :menu="sidemenuUpdate ? sidemenuUpdate : sidemenu"
        :data-school-list="schoolDataList"
        :data-branch-list="branchDataList"
        :schoolDefaultId="schoolDefaultId"
        :branchDefaultId="branchDefaultId"
      />

      <div
        class="base-content-default"
        :class="{ 'base-content-default-slide': !isAsideMobileExpanded }"
      >
        <NavBar :module="masterModule" />

        <RouterView v-slot="{ Component }">
          <component
            :is="Component"
            :departmentDefault="departmentDefault"
            :departmentListActive="departmentListActive"
            :academicDefault="academicDefault"
            :academicListActive="academicListActive"
            :levelDefault="levelDefault"
            :levelListActive="levelListActive"
            :semesterDefault="semesterDefault"
            :semesterListActive="semesterListActive"
            :subjectListActive="subjectListActive"
          />
        </RouterView>

        <FooterBar />
      </div>
    </div>

    <!-- Modal component -->
    <overlay
      v-show="isAsideLgActive"
      z-index="z-30"
      @overlay-click="overlayClick"
    />
  </div>
  <!-- </div> -->
</template>

<script>
/* eslint-disable */
import {
  computed,
  ref,
  reactive,
  watch,
  watchEffect,
  onMounted,
  onUnmounted,
  onBeforeMount,
} from "vue";
import { useStore } from "vuex";
import { useI18n } from "vue-i18n";
import { useRouter, useRoute } from "vue-router";
import axios from "axios";
import CryptoJS from "crypto-js";
import "@tailwindcss/forms/dist/forms.min.css";

import menu from "@/menu.js";
import menuUser from "@/menuParentAndStudent.js";
import menuEmployee from "@/menuEmployee.js";
import menuFinanceAdm from "@/menuFinanceAdm.js";
import menuFinance from "@/menuFinance.js";
import menuTeacher from "@/menuTeacher.js";

import menuHeadMaster from "@/menuHeadMaster.js";
import menuConsellor from "@/menuConsellor.js";
import menuComboard from "@/menuComboard.js";
import menuBooking from "@/menuBooking.js";
import menuCourseAll from "@/menuCourseAll.js";
import menuModule from "@/menuModule.js";
import menuManagement from "@/menuManagement.js";
import NavBar from "@/components/NavBar";
import AsideMenu from "@/components/AsideMenu";
import FooterBar from "@/components/FooterBar";
import Overlay from "@/components/Overlay";

import {
  getCheckRoleUser,
  getDepartmentData,
  getSubjectGroupData,
} from "@/composables/global";

export default {
  name: "APP",

  components: {
    Overlay,
    FooterBar,
    AsideMenu,
    NavBar,
  },

  data: function () {
    return {
      isAdminLayout: false,
      sidemenu: [],
      class_var: "",
      userObject: Object,
      masterModule: [],
    };
  },

  watch: {
    $route(to, from) {
      if (to.matched.length && to !== from) {
        this.isAdminLayout = this.checkRoleAdmin();
        this.sidemenu = this.mainmenu();
        this.class_var = this.classParent();
        this.userObject = this.userObj();

        this.masterModule = JSON.parse(localStorage.getItem("moduleList"));
      }
    },
  },

  methods: {
    subIsActive(input) {
      const paths = Array.isArray(input) ? input : [input];
      return paths.some((path) => {
        return this.$route.path.indexOf(path) === 0; // current path starts with this path string
      });
    },
    userObj() {
      // const store = useStore()
      // let user = undefined
      // if ($store.state)
      // {
      //   user = store.state.auth.user
      // }
      return "";
    },
    checkRoleAdmin() {
      if (localStorage.getItem("loginAs") === "administrator") {
        return true;
      } else {
        return false;
      }
    },
    mainmenu() {
      let menuStorage = localStorage.getItem("isActiveModule");
      const user_id = localStorage.getItem("user_id");
      const checkUser = ref(false);
      const checkUserFinance = ref(false);
      const checkUserTeacher = ref(false);
      const checkUserHeadMaster = ref(false);
      const checkUserYayasan = ref(false);
      const checkUserManagement = ref(false);
      const checkUserConselor = ref(false);
      const checkUserAdmin = ref(false);
      if (user_id !== null && localStorage.getItem("role")) {
        const decryptedMessage = CryptoJS.AES.decrypt(
          localStorage.getItem("role"),
          "amatra1609"
        ).toString(CryptoJS.enc.Utf8);
        const roles = decryptedMessage.split(",").map((r) => r.trim());

        checkUserTeacher.value =
          roles.includes("ROLE_TEACHER") || roles.includes("ROLE_HOMEROOM");
        checkUser.value = roles.includes("ROLE_ADMIN_FINANCE");
        checkUserFinance.value = roles.includes("ROLE_FINANCE");
        checkUserYayasan.value = roles.includes("ROLE_FOUNDATION");
        checkUserManagement.value = roles.includes("ROLE_MANAGEMENT");
        checkUserConselor.value = roles.includes("ROLE_CONSELOR");
        checkUserHeadMaster.value = roles.includes("ROLE_HEADMASTER");
        checkUserAdmin.value = roles.includes("ROLE_ADMIN");
      }

      // const userCheck = async () => {

      // }

      let listmenu = [];
      if (checkUserManagement.value == true) {
        listmenu = menuManagement;
      } else if (menuStorage == "ACA") {
        if (checkUserAdmin.value) {
          listmenu = menu;
        } else if (checkUserTeacher.value) {
          listmenu = menuTeacher;
        } else if (checkUserHeadMaster.value) {
          listmenu = menuHeadMaster;
        } else {
          if (checkUserConselor.value) {
            listmenu = menuConsellor;
          } else {
            listmenu = menu;
          }

          //  listmenu = menuCourseAll;
        }
      } else if (menuStorage == "FINA") {
        if (checkUserFinance.value) {
          listmenu = menuFinance;
        }
        if (checkUser.value || checkUserYayasan.value) {
          listmenu = menuFinanceAdm;
        }
      } else if (menuStorage == "HUCAP") {
        listmenu = menuEmployee;
      } else if (menuStorage == "COM") {
        listmenu = menuComboard;
      } else if (menuStorage == "BOOKING") {
        listmenu = menuBooking;
      } else if (menuStorage == "COURSE") {
        listmenu = menuCourseAll;
      } else {
        if (
          ["ADMISS", "AD", "REGIST", "SUBJECT", "CLUB"].includes(menuStorage)
        ) {
          listmenu = menuModule;
        }
      }

      return listmenu;
    },
    classParent() {
      let loginStorage = localStorage.getItem("loginAs");
      let class_var = "";

      if (loginStorage === "parent" || loginStorage === "student") {
        class_var = "parent-container";
      } else if (loginStorage === "booking") {
        class_var = "booking-container";
      }
      return class_var;
    },
  },

  setup() {
    const {
      departmentList,
      academicYearList,
      levelList,
      semesterList,
      subjectList,
      schoolDataList,
      branchDataList,
      departmentDefaultId,
      academicYearDefaultId,
      levelDefaultId,
      semesterDefaultId,
      schoolDefaultId,
      branchDefaultId,
      roleUserList,
    } = getCheckRoleUser({
      id: localStorage.getItem("user_id") ?? "",
    });

    const activeClone = (src, active) =>
      computed(
        () =>
          src.value
            ?.filter((i) => i.is_active === active)
            .map((i) => ({ ...i })) ?? []
      );

    const departmentListActive = activeClone(departmentList, true);
    const academicListActive = activeClone(academicYearList, 1);
    const levelListActive = activeClone(levelList, 1);
    const semesterListActive = activeClone(semesterList, 1);
    const subjectListActive = activeClone(subjectList, 1);

    const departmentDefault = computed(() => departmentDefaultId.value);
    const academicDefault = computed(() => academicYearDefaultId.value);
    const levelDefault = computed(() => levelDefaultId.value);
    const semesterDefault = computed(() => semesterDefaultId.value);

    const dataModuleCard = ref([]);
    const dataModuleAdmin = ref([]);

    const CACHE_KEY = "module_cache";
    const CACHE_TTL = 1000 * 60 * 60;

    const getModule = async () => {
      const cacheRaw = localStorage.getItem(CACHE_KEY);

      if (cacheRaw) {
        const cache = JSON.parse(cacheRaw);

        if (Date.now() - cache.timestamp < CACHE_TTL) {
          dataModuleCard.value = cache.card;
          dataModuleAdmin.value = cache.admin;
          return;
        }
      }

      try {
        const headers = { "Content-Encoding": "gzip" };

        const [modCard, modAdm] = await Promise.all([
          axios.get("module", { headers, params: { type: "card" } }),
          axios.get("module", { headers, params: { type: "admin" } }),
        ]);

        dataModuleCard.value = modCard.data.data ?? [];
        dataModuleAdmin.value = modAdm.data.data ?? [];

        localStorage.setItem(
          CACHE_KEY,
          JSON.stringify({
            card: dataModuleCard.value,
            admin: dataModuleAdmin.value,
            timestamp: Date.now(),
          })
        );
      } catch (e) {
        console.error(e);
      }
    };

    onBeforeMount(getModule);

    const router = useRouter();
    const route = useRoute();
    const { t } = useI18n({ useScope: "global" });
    const store = useStore();
    const isAsideMobileExpanded = computed(
      () => store.state.isAsideMobileExpanded
    );
    const user = ref({});
    const userRole = localStorage.getItem("roles");
    const parentRole = localStorage.getItem("loginAs") === "parent";
    const studentRole = localStorage.getItem("loginAs") === "student";
    const bookingRole = localStorage.getItem("loginAs") === "booking";
    // store.state.auth.user = null
    if (store.state.auth.user) {
      store.commit("user", {
        name: store.state.auth.user.name,
        email: store.state.auth.user.email,
        avatar: "",
      });
      user.value = store.state.auth.user;
    }
    const isAsideLgActive = computed(() => store.state.isAsideLgActive);

    const overlayClick = () => {
      store.dispatch("asideLgToggle", false);
    };
    const limitLogin = async () => {
      const url = "check-limit-login";
      const method = "POST";

      const params = {
        user_id: localStorage.getItem("user_id"),
        loginAS: localStorage.getItem("loginAs"),
      };

      await axios({
        method,
        url,
        params,
      })
        .then((response) => {
          if (response.data.olddate < response.data.newdate) {
            // router.push(response.data.status)
            // localStorage.clear()
          }
        })
        .catch((error) => {
          console.log(error);
          let status = "/login";
          if (localStorage.getItem("loginAs") == "student") {
            status = "/login-student";
          } else if (localStorage.getItem("loginAs") == "parent") {
            status = "/login-parent";
          } else if (localStorage.getItem("loginAs") == "booking") {
            status = "/login-booking";
          }

          router.push(status);
          // localStorage.clear()
        });
    };

    const dataModuleSchool = ref([]);
    const statusTheme = computed(() => process.env.VUE_APP_DEFAULT_THEME);
    const getAllData = async (date) => {
      const headers = { "Content-Encoding": "gzip" };

      try {
        const [response1, modSch] = await Promise.all([
          axios.get("general-setting", { headers }),
          axios.get("get-school", { headers }),
        ]);

        if (response1.data.data) {
          localStorage.setItem("BasicTheme", response1.data.data.value);
          statusTheme.value = response1.data.data.value;
        }

        dataModuleSchool.value = modSch.data?.data ?? [];
      } catch (error) {
        console.log(error);
      }
    };

    const userId = computed(() => localStorage.getItem("user_id"));
    const totalChild = reactive({
      total: 0,
      state: false,
    });
    const sidemenuUpdate = [];

    const getSetData = async () => {
      const thisDate = new Date();
      let thisYear = thisDate.getFullYear();
      let thisMonth = ("0" + (thisDate.getMonth() + 1)).slice(-2);
      const monthNow = thisYear + "-" + thisMonth;

      const headers = { "Content-Encoding": "gzip" };

      const testParams1 = {
        user_id: userId.value,
        is_personal: 0,
        year: thisYear,
        month: thisMonth,
      };

      try {
        const [response1] = await Promise.all([
          axios.get("get-leave-history", { headers, params: testParams1 }),
        ]);

        if (response1.data.data) {
          const backData = response1.data.data;
          // totalChild.total = backData[0].child_list.length
          if (response1.data.data.length > 0) {
            totalChild.total =
              backData.length < 2
                ? backData[0].child_list.length
                : backData.length;
            totalChild.state = totalChild.total != 0 ? true : false;
            localStorage.setItem("child", totalChild);

            if (totalChild.state) {
              sidemenuUpdate.value = menuEmployee;
            }
          }
        }
      } catch (error) {
        console.log(error);
      }
    };

    onBeforeMount(() => {
      getAllData();
    });

    watchEffect(() => {
      if (
        route.path == "/login" ||
        route.path == "/login-booking" ||
        route.path == "/login-parent" ||
        route.path == "/login-student" ||
        route.path == "/reset-password" ||
        route.path == "/change-password" ||
        route.path == "/change-password-booking" ||
        route.path == "/change-password-parent" ||
        route.path == "/change-password-student"
      ) {
        getAllData();
      }

      if (route.path == "/hr-dashboard") {
        getSetData();
      }
    });

    onMounted(() => {
      if (document.readyState == "complete") {
        // fetch to next page or some code
      }
      // userCheck()
      // limitLogin()

      // if(localStorage.getItem('loginAs') === 'administrator') {
      //   checkRoleAdmin.value === true
      // } else {
      //   checkRoleAdmin.value === false
      // }
    });

    return {
      departmentDefault,
      departmentListActive,
      academicDefault,
      academicListActive,
      levelDefault,
      levelListActive,
      semesterDefault,
      semesterListActive,
      subjectListActive,
      dataModuleCard,
      dataModuleAdmin,
      dataModuleSchool,
      router,
      route,
      menu,
      menuUser,
      menuEmployee,
      menuFinanceAdm,
      menuHeadMaster,
      menuTeacher,
      menuConsellor,
      menuFinance,
      menuComboard,
      menuBooking,
      menuModule,
      menuManagement,
      isAsideLgActive,
      isAsideMobileExpanded,
      overlayClick,
      t,
      parentRole,
      studentRole,
      bookingRole,
      statusTheme,
      schoolDataList,
      branchDataList,
      schoolDefaultId,
      branchDefaultId,
    };
  },
  mounted() {
    //  [App.vue specific] When App.vue is finish loading finish the progress bar
    this.$Progress.finish();
  },
  created() {
    //  [App.vue specific] When App.vue is first loaded start the progress bar
    this.$Progress.start();
    //  hook the progress bar to start before we move router-view
    // this.$router.beforeEach((to, from, next) => {
    //   //  does the page we want to go to have a meta.progress object
    //   if (to.meta.progress !== undefined) {
    //     const meta = to.meta.progress
    //     // parse meta tags
    //     this.$Progress.parseMeta(meta)
    //   }
    //   //  start the progress bar
    //   this.$Progress.start()
    //   //  continue to next page
    //   next()
    // })
    //  hook the progress bar to finish after we've finished moving router-view
    this.$router.afterEach((to, from) => {
      //  finish the progress bar
      this.$Progress.finish();
    });
  },
  beforeCreate() {
    const store = useStore();
    const router = useRouter();

    axios.interceptors.response.use(
      function (response) {
        return response;
      },
      function (error) {
        console.log("error axios 401", error);
        if (error && error.response && error.response.status === 401) {
          let loginAs = localStorage.getItem("loginAs");
          if (loginAs === "administrator") {
            store.dispatch("logout").then(() => {
              router.push("/login");
            });
          }
          if (loginAs === "student") {
            store.dispatch("logoutStudent").then(() => {
              router.push("/login-student");
            });
          }
          if (loginAs === "parent") {
            store.dispatch("logoutParent").then(() => {
              router.push("/login-parent");
            });
          }
          if (loginAs === "booking") {
            store.dispatch("logoutBooking").then(() => {
              router.push("/login-booking");
            });
          }
        }
        return Promise.reject(error);
      }
    );
  },
};
</script>
